import { css } from 'styled-components';

import { routeLoadingOneIfLoadingElseZeroVar } from './routeLoading';
import { transition } from './theme';

// We're discussing an appropriate effect
// TODO: update here once we have a decision
export const navigationTransitionCss = css`
  opacity: calc(1 - var(${routeLoadingOneIfLoadingElseZeroVar}) * 0.25);
  transition: ${transition};
`;
